import { h, Component } from 'preact';
import { translate } from 'react-i18next';

import Button from './Button.js';


class OtherSettingsGrids extends Component {

	addMore = () => {
		this.setState({ btnLoadMore: 'loading' });
		const n = this.state.number;
		this.setState({ number: n + 3 });
		this.setState({ btnLoadMore: 'initial' });
		if (n === 6) {
			if (this.props.type === 'transactions') {
				this.setState({ buttonText: 'View all transactions' });
			}
			else {
				this.setState({ buttonText: 'View all rewards' });
			}
		}
		if (n >= 9) {
			this.setState({
				number: 1000,
				button: false
			});
		}
	}

	constructor(props) {
  	super(props);
  	this.state = {
			transactionsData: null,
			rewardsData: null,
			affiliatesData: null,
			number: 3,
			button: true,
			buttonText: 'View more transactions',
			show: true,
			btnLoadMore: 'initial'
  	};
	}

	
	componentDidMount() {
		fetch('https://api.hirezstudios.com/acct/transactions', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: `{"webToken": "${this.props.webToken}"}`
		}).then((response) => response.json()).then((response) => {
			this.setState({ transactionsData: response });
			});
	}

	componentDidUpdate(prevProps) {
		if (this.props.type !== prevProps.type) {
			this.setState({ number: 3 });
			this.setState({ button: true });
			if (this.props.type === 'transactions') {
				this.setState({ buttonText: 'View more transactions' });
			}
			else {
				this.setState({ buttonText: 'View more rewards' });
			}
			if (this.props.type && this.state[this.props.type + 'Data'] === null) {
				fetch(`https://api.hirezstudios.com/acct/${this.props.type}`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: `{"webToken": "${this.props.webToken}"}`
				}).then((response) => response.json()).then((response) => {
					response.length === 0 ? this.setState({ show: this.props.type }) : this.setState({ [this.props.type + 'Data']: response });
				});
			}
		}
	}


	render() {
		const { t } = this.props;
		return (
			<div className="grid-container">
				<div className="grids">
					<div className={`no-data ${this.state.show  === this.props.type ? 'true' : 'false'}`}>{this.props.type === 'transactions' ? t(`There are no transactions to display`) : t(`There are no rewards to display`) }</div>
					{this.state.show !== this.props.type &&
						<div className={`transactions ${this.props.type === 'transactions' ? ' active' : ''}`}>
							<div className="info">
								<table key={'transactions'}>
									<thead>
										<th>{t('Date of Purchase')}</th>
										<th>{t('Description')}</th>
										<th>{t('Order Number')}</th>
										<th>{t('Gift')}</th>
									</thead>
									<tbody>
										{this.state.transactionsData && this.state.transactionsData.slice(0, this.state.number).map((data) =>
											(<tr className="info" key={data.creation_dt}>
												<td>{data.creation_dt.split('T')[0]}</td>
												<td>{data.item_name}</td>
												<td>{data.order_no}</td>
												<td>{`${data.gift_recipient_player !== null ? data.gift_recipient_player : 'N/A'}`}</td>
											</tr>)
										)}
									</tbody>
								</table>
								{this.state.button === true &&
									<div className="buttons-wrapper">
										<Button
											color="blue"
											copy={t(this.state.buttonText)}
											state={t(this.state.btnLoadMore)}
											onClick={this.addMore}
										/>
									</div>	
								}
							</div>
						</div>
					}
					{this.state.show !== this.props.type &&
						<div className={`rewards ${this.props.type === 'rewards' ? ' active' : ''}`}>
							<div className="info">
								<table key={'rewards'}>
									<thead>
										<th>{t('Date')}</th>
										<th>{t('Program')}</th>
										<th>{t('Order Number')}</th>
										<th>{t('Points Earned')}</th>
										<th>{t('Game')}</th>
										<th>{t('Status')}</th>
									</thead>
									<tbody>
										{this.state.rewardsData && this.state.rewardsData.slice(0, this.state.number).map((data) =>
											(<tr className="info" key={data.creation_dt}>
												<td>{data.creation_dt}</td>
												<td>{data.provider}</td>
												<td>{data.transaction_id}</td>
												<td>{data.award}</td>
												<td>{data.game}</td>
												<td>{data.status}</td>
											</tr>)
										)}
									</tbody>
								</table>
								{this.state.button === true &&
									<div className="buttons-wrapper">
										<Button
											color="blue"
											copy={t(this.state.buttonText + this.props.type)}
											state={this.state.btnLoadMore}
											onClick={this.addMore}
										/>
									</div>
								}
							</div>
						</div>
					}
					{this.state.show !== this.props.type &&
						<div className={`affiliates ${this.props.type === 'affiliates' ? ' active' : ''}`}>
							<div className="info">
								<table key={'affiliates'}>
									<thead>
										<th>{t('Date')}</th>
										<th>{t('UTM Campaign')}</th>
										<th>{t('Total Revenue')}</th>
										<th>{t('UTM Content')}</th>
										<th>{t('Accounts Created')}</th>
									</thead>
									<tbody>
										{this.state.affiliatesData && this.state.affiliatesData.slice(0, 1000).map((data) =>
											(<tr className="info" key={data.time_period}>
												<td>{data.time_period}</td>
												<td>{data.utm_campaign}</td>
												<td>{data['total_revenue_' + this.props.currency]}</td>
												<td>{data.utm_content}</td>
												<td>{data.new_and_paying_accounts_created}</td>
											</tr>)
										)}
									</tbody>
								</table>
							</div>
						</div>
					}
				</div>
			</div>
		);
	}
}

export default translate(['common'], { withRef: true })(OtherSettingsGrids);


// WEBPACK FOOTER //
// ./components/OtherSettingsGrids.js